// Markdown renderer — uses react-markdown (already a project dependency), which
// does not render raw HTML by default, so content is rendered safely.

import ReactMarkdown from "react-markdown";

interface MarkdownProps {
  content: string;
}

export function Markdown({ content }: MarkdownProps) {
  return (
    <div className="markdown-content">
      <ReactMarkdown>{content || ""}</ReactMarkdown>
    </div>
  );
}

export default Markdown;
